<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <b-card>
          <div slot="header">
            <strong>{{$t('NEWUSERCOMPANY')}}</strong>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('COMPANYNAME')">
                <inputvalidation :formerror="formError" name="companyName"><b-form-input type="text" v-model="formData.companyName" v-bind:placeholder="$t('COMPANYNAME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div slot="footer">
            <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
            <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="saveRow(formData)"><i class="fa fa-dot-circle-o"></i> {{$t('SUBMIT')}}</b-button>
          </div>
        </b-card>
      </div><!--/.col-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> {{$t('USERCOMPANIES')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('SAVE')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in data.root">
                    <td>{{item.companyId}}</td>
                    <td><b-form-input type="text" v-model="item.companyName"></b-form-input></td>
                    <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="saveRow(item)"><icon name="save"></icon> {{$t('SAVE')}}</b-button></td>
                    <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.companyId)"><icon name="ban"></icon> {{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Api from '@/api/admin/UserCompanies'

export default {
  name: 'UserCompanies',
  data: function()
  {
    return {
      data: {},
      formError: {},
      formData:
      {
        companyName: ''
      },
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      }
    }
  },
  created: function()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    saveRow: function(item)
    {
      var me = this;

      if(typeof item.companyId != 'undefined')
      {
        item.id = item.companyId;
        delete(item.companyId);
      }

      Api.save(item, function(val)
      {
        if(val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.getData();
        }
      })
    },
    getData: function()
    {
      var me = this;
      Api.selectRow(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.notice(data);
          return;
        }
        me.data = data;
      });
    },
    deleteRow: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          Api.deleteRow({id: id}, function(data)
          {
            if(data.error && data.error == true) me.$notify.error(data.notice);
            else me.$notify.success(data.notice);
            me.getData();
          })
        }
      })
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
